module.exports = __webpack_public_path__ + "4a50648c4b3d0bfb78c2d86e2c29a5de.vtt";